import React from 'react';
import { Box, Button, TextField, SelectChangeEvent } from '@mui/material';
import Dropdown from '../../Components/DropDown/drop-down.tsx';
// (Action import is usually used in the parent component that fetches data, but kept here if needed)
import { getAssignedUsers } from './action.ts'; 

interface AddDeploymentModalProps {
    companyOptions: { id: string; label: string }[];
    selectedCompany: string;
    handleCompanyChange: (event: SelectChangeEvent<string>) => void;
    platformModelOptions: { id: string; label: string }[];
    deploymentDevice: string;
    setDeploymentDevice: (val: string) => void;
    vehicleOptions: { id: string; label: string }[];
    selectedVehicle: string;
    setSelectedVehicle: (val: string) => void;
    
    // NEW PROPS FOR ASSIGNED USER
    assignedUserOptions: { id: string; label: string }[];
    selectedAssignedUser: string;
    setSelectedAssignedUser: (val: string) => void;
    
    remarks: string;
    setRemarks: (val: string) => void;
    handleSaveDeployment: () => void;
}

const AddDeploymentModal: React.FC<AddDeploymentModalProps> = ({
    companyOptions,
    selectedCompany,
    handleCompanyChange,
    platformModelOptions,
    deploymentDevice,
    setDeploymentDevice,
    vehicleOptions,
    selectedVehicle,
    setSelectedVehicle,
    
    // NEW PROPS
    assignedUserOptions,
    selectedAssignedUser,
    setSelectedAssignedUser,
    
    remarks,
    setRemarks,
    handleSaveDeployment
}) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1, pb: 2, justifyContent: 'center', alignItems: 'center' }}>
            <Box>
                <Dropdown 
                    options={companyOptions}
                    selectedValue={selectedCompany}
                    handleChange={handleCompanyChange}
                    placeholder="Select Company"
                    label="Choose Company"
                    height="40px"
                    width="250px"
                    searchable={true}
                />
            </Box>
            
            <Box>
                <Dropdown 
                    options={platformModelOptions}
                    selectedValue={deploymentDevice}
                    handleChange={(e: SelectChangeEvent<string>) => setDeploymentDevice(e.target.value)}
                    placeholder="Select Device Type"
                    label="Device Type"
                    height="40px"
                    width="250px"
                />
            </Box>
            
            <Box>
                <Dropdown 
                    options={vehicleOptions}
                    selectedValue={selectedVehicle}
                    handleChange={(e: SelectChangeEvent<string>) => setSelectedVehicle(e.target.value)}
                    placeholder={selectedCompany ? "Select Vehicle" : "Select a Company First"}
                    label="Vehicle Number"
                    height="40px"
                    width="250px"
                    searchable={true}
                    disabled={!selectedCompany || vehicleOptions.length === 0}
                />
            </Box>

            {/* NEW ASSIGNED USER DROPDOWN */}
            <Box>
                <Dropdown 
                    options={assignedUserOptions}
                    selectedValue={selectedAssignedUser}
                    handleChange={(e: SelectChangeEvent<string>) => setSelectedAssignedUser(e.target.value)}
                    placeholder={ "Select Assigned User"}
                    label="Assign User"
                    height="40px"
                    width="250px"
                    searchable={true}
                    disabled={!selectedCompany || assignedUserOptions.length === 0}
                />
            </Box>
            
            <Box>
                <TextField 
                    label="Remarks" 
                    size="small" 
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    multiline
                    rows={2}
                    sx={{ width: '250px' }} 
                />
            </Box>
            
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                <Button variant="contained" className="custom-button" onClick={handleSaveDeployment}>
                    Save Deployment
                </Button>
            </Box>
        </Box>
    );
};

export default AddDeploymentModal;